import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './keycloak';
import reportWebVitals from './reportWebVitals';
import { BASEPATH } from './global';

function eventLogger(event, error) {
  // const now = new Date();
  // console.log(now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + ' onKeycloakEvent:', event, 'error:', error ? error : 'none');
}

function tokenLogger(tokens) {
  if (tokens && tokens.token) {
    localStorage.setItem('justredi_token', tokens.token)
    localStorage.setItem('justredi_idToken', tokens.idToken)
    localStorage.setItem('justredi_refreshToken', tokens.refreshToken)
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ReactKeycloakProvider authClient={keycloak} onEvent={(e, r) => { eventLogger(e, r); }} onTokens={e => { tokenLogger(e); }} initOptions={{
    token: localStorage.getItem('justredi_token'),
    idToken: localStorage.getItem('justredi_idToken'),
    refreshToken: localStorage.getItem('justredi_refreshToken'),
    checkLoginIframe: true,
    silentCheckSso: true,
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso'//`${location.origin}/justredi/silent-check-sso.html`
  }}>
    <BrowserRouter basename={BASEPATH}>
      <div id='app'>
        <App />
        {/* <App msalInstance={msalInstance} /> */}
      </div>
    </BrowserRouter>
  </ReactKeycloakProvider>,
);

reportWebVitals();
